import React from "react"
import styles from "./styles.scss"
import coverimage from "images/small.jpg"
import CompanyPart from "./CompanyPart"

class Company extends React.Component {
  render() {
    const { company } = this.props
    const city = company.companyCounties[0].name

    return (
      <div className={styles.container}>
        <div className={styles.coverImage}  style={{ backgroundImage: `url(${coverimage})` }}>
        <div className={styles.companyWrapper}>
          <div className={styles.companyLogoWrapper}>
            <div className={styles.companyLogo} style={{ backgroundImage: company.logoUrl? `url(${company.logoUrl})` : `url("https://s3.eu-west-3.amazonaws.com/newemil/BILD-SAKNAS.gif")` }}/>
          </div>
          <div className={styles.companyInfo}>
            <h2> {company.name} </h2>
            <p> Företag i <strong>{city}</strong> </p>
          </div>
          </div>
        </div>

        <CompanyPart text={company.phone} buttonText="Ring"/>
        <CompanyPart text={company.email} buttonText="Maila"/>
        <CompanyPart text={city} buttonText="Karta"/>
      </div>
    )
  }
}

export default Company



// WEBPACK FOOTER //
// src/pages/CompanyShow/Company/index.jsx